<template>
  <div class="min-h-screen bg-light-grey">
    <jet-banner />

    <div class="bg-light-grey">
      <nav class="bg-vice-teal-500">
        <!-- Primary Navigation Menu -->
        <div class="mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex justify-between h-16">
            <!-- Logo -->
            <div class="flex-shrink-0 flex items-center">
              <inertia-link :href="route('dashboard')">
                <jet-application-mark class="block h-8 w-auto" />
              </inertia-link>
            </div>

            <!-- Navigation Links -->
            <div class="flex items-center">
              <!-- Navigation Links -->
              <div
                class="hidden max-h-9 items-center space-x-2 sm:-my-px sm:-ml-24 lg:flex font-bold"
              >
                <jet-nav-link
                  data-cy="user-sessions"
                  :href="route('dashboard')"
                  :active="route().current('dashboard') && activeTab == ''"
                >
                  Dashboard
                </jet-nav-link>
                <a
                  class="
                    py-2
                    px-3
                    hover:text-base
                    hover:bg-vice-teal-600
                    rounded-md
                    text-xs text-white
                    transition
                  "
                  data-cy="professional-course-dashboard"
                  :href="courseUrl"
                  target="_blank"
                >
                  Professionalism course
                </a>
              </div>
              <!-- <div class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                <jet-nav-link :href="route('dashboard')" :active="false">Clinicians</jet-nav-link>
                <jet-nav-link :href="route('dashboard')" :active="false">About ViCE</jet-nav-link>
              </div> -->
            </div>

            <div class="hidden sm:flex sm:items-center sm:ml-6">
              <div @click="openIntercom" class="flex cursor-pointer">
                <span
                  class="
                    px-2
                    py-1
                    text-xs
                    font-medium
                    text-white
                    border border-red-400
                    hover:bg-vice-teal-600
                    rounded-full
                  "
                >
                  Support
                </span>
              </div>
              <div class="ml-3 relative">
                <!-- Teams Dropdown -->
                <jet-dropdown align="right" width="60" v-if="$page.props.jetstream.hasTeamFeatures">
                  <template #trigger>
                    <span class="inline-flex rounded-md">
                      <button
                        type="button"
                        class="
                          inline-flex
                          items-center
                          px-3
                          py-2
                          border border-transparent
                          text-sm
                          leading-4
                          font-medium
                          rounded-md
                          text-gray-500
                          bg-white
                          hover:bg-gray-50
                          hover:text-gray-700
                          focus:outline-none
                          focus:bg-gray-50
                          active:bg-gray-50
                          transition
                        "
                      >
                        {{ $page.props.user.current_team.name }}

                        <svg
                          class="ml-2 -mr-0.5 h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707
                            7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0
                            011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0
                            01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>
                  </template>

                  <template #content>
                    <div class="w-60">
                      <!-- Team Management -->
                      <template v-if="$page.props.jetstream.hasTeamFeatures">
                        <div class="block px-4 py-2 text-xs text-gray-400">Manage Team</div>

                        <!-- Team Settings -->
                        <jet-dropdown-link
                          :href="route('teams.show', $page.props.user.current_team)"
                        >
                          Team Settings
                        </jet-dropdown-link>

                        <jet-dropdown-link
                          :href="route('teams.create')"
                          v-if="$page.props.jetstream.canCreateTeams"
                        >
                          Create New Team
                        </jet-dropdown-link>

                        <div class="border-t border-gray-100"></div>

                        <!-- Team Switcher -->
                        <div class="block px-4 py-2 text-xs text-gray-400">Switch Teams</div>

                        <template v-for="team in $page.props.user.all_teams" :key="team.id">
                          <form @submit.prevent="switchToTeam(team)">
                            <jet-dropdown-link as="button">
                              <div class="flex items-center">
                                <svg
                                  v-if="team.id == $page.props.user.current_team_id"
                                  class="mr-2 h-5 w-5 text-green-400"
                                  fill="none"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <div>{{ team.name }}</div>
                              </div>
                            </jet-dropdown-link>
                          </form>
                        </template>
                      </template>
                    </div>
                  </template>
                </jet-dropdown>
              </div>

              <!-- Settings Dropdown -->
              <div class="ml-3 relative step-student-profile">
                <div
                  class="
                    flex
                    text-sm
                    border-2 border-transparent
                    rounded-full
                    focus:outline-none
                    focus:border-gray-300
                    transition
                  "
                >
                  <div class="ml-3 relative">
                    <jet-dropdown align="right" width="48">
                      <template #trigger>
                        <div class="flex items-center cursor-pointer">
                          <button
                            v-if="$page.props.jetstream.managesProfilePhotos"
                            class="
                              flex
                              text-sm
                              border-2 border-transparent
                              rounded-full
                              focus:outline-none
                              focus:border-gray-300
                              transition
                            "
                          >
                            <ViceAvatar
                              :image="$page.props.user.profile_photo_url"
                              :name="$page.props.user.name"
                              class="w-8 h-8"
                            />
                          </button>

                          <span v-else class="inline-flex rounded-md">
                            <button
                              type="button"
                              class="inline-flex py-2 px-3 text-xs text-white transition"
                            >
                              {{ $page.props.user.name }}

                              <svg
                                class="ml-2 -mr-0.5 h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1
                                  1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </button>
                          </span>

                          <p class="inline-flex py-2 px-2 text-xs text-white transition">
                            {{ $page.props.user.name }}
                          </p>
                        </div>
                      </template>

                      <template #content>
                        <!-- Account Management -->
                        <div class="block px-4 py-2 text-xs text-gray-400">Manage account</div>

                        <jet-dropdown-link
                          data-cy="user-profile-settings"
                          :href="route('profile.show')"
                        >
                          Profile
                        </jet-dropdown-link>
                        <jet-dropdown-link
                          data-cy="user-api-tokens"
                          :href="route('api-tokens.index')"
                          v-if="$page.props.jetstream.hasApiFeatures"
                        >
                          API Tokens
                        </jet-dropdown-link>

                        <div class="border-t border-gray-100"></div>

                        <!-- Authentication -->
                        <form @submit.prevent="logout">
                          <jet-dropdown-link as="button" data-cy="user-log-out">
                            Log out
                          </jet-dropdown-link>
                        </form>
                      </template>
                    </jet-dropdown>
                  </div>

                  <!-- <div
                                        class="
                                            h-8
                                            w-8
                                            content-center
                                            rounded-full
                                            object-cover
                                            mt-0.5
                                            bg-vice-teal-700
                                            mr-2
                                            p-1.5
                                        ">
                                        <BellIcon class="h-5 w-5 mr-1 text-light-grey" />
                                    </div>
                                    <div
                                        class="
                                            h-8
                                            w-8
                                            content-center
                                            rounded-full
                                            object-cover
                                            mt-0.5
                                            bg-vice-teal-700
                                            p-1.5
                                        ">
                                    <QuestionMarkCircleIcon class="h-5 w-5 mr-1 text-light-grey" />
                                    </div> -->
                </div>
              </div>
            </div>

            <!-- Hamburger -->
            <div class="-mr-2 flex items-center sm:hidden">
              <button
                @click="showingNavigationDropdown = !showingNavigationDropdown"
                class="
                  inline-flex
                  items-center
                  justify-center
                  p-2
                  rounded-md
                  text-white
                  hover:text-gray-400
                  focus:outline-none
                  focus:bg-gray-100
                  focus:text-gray-500
                  transition
                "
              >
                <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    :class="{
                      hidden: showingNavigationDropdown,
                      'inline-flex': !showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                  <path
                    :class="{
                      hidden: !showingNavigationDropdown,
                      'inline-flex': showingNavigationDropdown,
                    }"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Responsive Navigation Menu -->
        <div
          :class="{ block: showingNavigationDropdown, hidden: !showingNavigationDropdown }"
          class="sm:hidden"
        >
          <div class="pt-2 pb-3 space-y-1">
            <jet-responsive-nav-link
              :href="route('dashboard')"
              :active="route().current('dashboard')"
            >
              Dashboard
            </jet-responsive-nav-link>
          </div>

          <!-- Responsive Settings Options -->
          <div class="pt-4 pb-1 border-t border-gray-200">
            <div class="flex items-center px-4">
              <div class="flex-shrink-0 mr-3">
                <ViceAvatar
                  :image="$page.props.user.profile_photo_url"
                  :name="$page.props.user.name"
                  class="w-10 h-10"
                />
              </div>

              <div>
                <div class="font-medium text-base text-gray-800">{{ $page.props.user.name }}</div>
                <div class="font-medium text-sm text-gray-800">{{ $page.props.user.email }}</div>
              </div>
            </div>

            <div class="mt-3 space-y-1">
              <jet-responsive-nav-link
                :href="route('profile.show')"
                :active="route().current('profile.show')"
              >
                Profile
              </jet-responsive-nav-link>

              <jet-responsive-nav-link
                :href="route('api-tokens.index')"
                :active="route().current('api-tokens.index')"
                v-if="$page.props.jetstream.hasApiFeatures"
              >
                API Tokens
              </jet-responsive-nav-link>

              <!-- Authentication -->
              <form method="POST" @submit.prevent="logout">
                <jet-responsive-nav-link as="button">Log out</jet-responsive-nav-link>
              </form>

              <!-- Team Management -->
              <template v-if="$page.props.jetstream.hasTeamFeatures">
                <div class="border-t border-gray-200"></div>

                <div class="block px-4 py-2 text-xs text-gray-400">Manage Team</div>

                <!-- Team Settings -->
                <jet-responsive-nav-link
                  :href="route('teams.show', $page.props.user.current_team)"
                  :active="route().current('teams.show')"
                >
                  Team Settings
                </jet-responsive-nav-link>

                <jet-responsive-nav-link
                  :href="route('teams.create')"
                  :active="route().current('teams.create')"
                  v-if="$page.props.jetstream.canCreateTeams"
                >
                  Create New Team
                </jet-responsive-nav-link>

                <div class="border-t border-gray-200"></div>

                <!-- Team Switcher -->
                <div class="block px-4 py-2 text-xs text-gray-400">Switch Teams</div>

                <template v-for="team in $page.props.user.all_teams" :key="team.id">
                  <form @submit.prevent="switchToTeam(team)">
                    <jet-responsive-nav-link as="button">
                      <div class="flex items-center">
                        <svg
                          v-if="team.id == $page.props.user.current_team_id"
                          class="mr-2 h-5 w-5 text-green-400"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <div>{{ team.name }}</div>
                      </div>
                    </jet-responsive-nav-link>
                  </form>
                </template>
              </template>
            </div>
          </div>
        </div>
      </nav>

      <!-- Page Heading -->
      <header class="bg-white" v-if="$slots.header">
        <div class="max-w-6xl mx-auto pt-6 px-2 sm:px-6 lg:px-8">
          <slot name="header"></slot>
        </div>
      </header>

      <!-- Page Content -->
      <TermsOfUse v-show="activeTab === 'terms'" />
      <main v-show="activeTab === ''">
        <div class="max-w-6xl mx-auto">
          <!--          <TwoFactorAuthAlert />-->
          <!--          <ProfilePictureAlert />-->
        </div>
        <slot></slot>
      </main>
    </div>
  </div>
  <BrowserCheckModal />
  <TwoFactorAuthModal />
</template>

<script>
// import { BellIcon, QuestionMarkCircleIcon } from '@heroicons/vue/outline';

import axios from 'axios';
import { Intercom, shutdown, show } from '@intercom/messenger-js-sdk';
import Cookies from 'js-cookie';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue';
import JetBanner from '@/Jetstream/Banner.vue';
import JetDropdown from '@/Jetstream/Dropdown.vue';
import JetDropdownLink from '@/Jetstream/DropdownLink.vue';
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';
import TermsOfUse from '../Pages/TermsOfUse.vue';
import { INTERCOM_APP_ID, ALERTS_SEEN_COOKIES_NAMES } from '@/Utils/vice-constants';
import BrowserCheckModal from '@/Components/Modals/BrowserCheckModal.vue';
import TwoFactorAuthModal from '@/Components/Modals/TwoFactorAuthModal.vue';
// import ProfilePictureAlert from '@/Components/Alerts/ProfilePictureAlert.vue';
// import TwoFactorAuthAlert from '@/Components/Alerts/TwoFactorAuthAlert.vue';

export default {
  props: {
    tab: {
      type: String,
      default: '',
    },
  },
  components: {
    // BellIcon,
    // QuestionMarkCircleIcon,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
    ViceAvatar,
    TermsOfUse,
    BrowserCheckModal,
    // ProfilePictureAlert,
    // TwoFactorAuthAlert,
    TwoFactorAuthModal,
  },

  data() {
    return {
      user: this.$page.props.user,
      showingNavigationDropdown: false,
      courseUrl: this.$page.props.defaultCourseUrl,
      courseRequired: process.env.MIX_ASSESSMENT_REQUIRED,
      activeTab: this.tab === 'terms-of-use' ? 'terms' : '',
    };
  },

  methods: {
    switchToTeam(team) {
      this.$inertia.put(
        route('current-team.update'),
        {
          team_id: team.id,
        },
        {
          preserveState: false,
        },
      );
    },

    logout() {
      Object.values(ALERTS_SEEN_COOKIES_NAMES).forEach((cookieName) => {
        Cookies.remove(cookieName);
      });

      axios.post(route('logout')).then(() => {
        shutdown();
        window.location.href = '/';
      });
    },
    openIntercom() {
      show();
    },
  },

  mounted() {
    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: this.user.unique_id,
      name: this.user.name,
      email: this.user.email,
      user_hash: this.user.user_hash,
      horizontal_padding: 20,
      vertical_padding: 20,
      hide_default_launcher: true,
    });
  },
};
</script>
<style scoped></style>
